"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.UIConfigSchema = exports.nodeType = void 0;
const zod_1 = require("zod");
exports.nodeType = 'file_generatedCashBalanceFeed';
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: zod_1.z.string().describe('Credit facility slug'),
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database.
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
// well not completely, because it may be modified by synthetic node creation
// later.
exports.artifactType = 'generatedCashBalanceFeed';
//# sourceMappingURL=types.js.map